// the prefix is used to wipe out all the session data from localStorage when current user logs out or another user logs in
// this is needed to prevent data leaks between different users
const USER_SESSION_PREFIX = "stackstate-user-session:";

export function isUserSessionKey(key: string): boolean {
	return key.startsWith(USER_SESSION_PREFIX);
}

export function userSessionKey(key: string): string {
	return `${USER_SESSION_PREFIX}${key}`;
}
